import React, { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
import axiosInstance from "../../Utils/API";
import {
  COMPANY_INVOICE,
  COMPANY_PRINT_INVOICE,
  APPPEND_DISCOUNT,
  COMPANY_PAYMENT,
  NEW_COMPANY_INVOICE,
} from "../../Utils/ApiGlobal";
// import { Lendger } from "../../Utils/Constants";
import TablePagination from "../UI/Table/TablewithPagination";
import moment from "moment";
import Loader from "../UI/Loader";
import Checkbox from "../UI/Checkbox";
import ButtonWithBG from "../UI/ButtonMain";
import { useHistory } from "react-router-dom";
import CategoryPill from "../UI/CategoryPill";
import { ConfirormationModal } from "../UI/ConfirormationModal";
import { CheckboxDes } from "../../Utils/Constants";

const Input = (props) => (
  <input
    className="peer  w-full px-3 py-2 uppercase  border border-gray-300 placeholder-gray-500  rounded-md focus:outline-none  focus:z-10 sm:text-sm text-center"
    {...props}
  />
);

export default function CompanyInvoiceTable(props) {
  // for Search
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [companyData, setCompanyData] = useState([]);
  const [invoiceData, setInvoiceData] = useState([]);
  const [hamali, setHamali] = useState(0);
  const [detention, setDetention] = useState(0);
  const [extraCharge, setExtraCharge] = useState(0);
  const [balance, setBalance] = useState(0);
  const [total, setTotal] = useState(0);
  // const [totalPaidToOwner, setTotalPaidToOwner] = useState(0);
  const [error, setError] = useState(false);
  const [note, setNote] = useState();
  const [companyAddress, setCompanyAddress] = useState();
  const [companyName, setCompanyName] = useState();
  const [companyGST, setCompanyGST] = useState();

  // Discount append
  const discountAppend = (e, d) => {
    let discountDetails = {
      Id: [d.bookingId],
      type: "Company",
      Discount: e.target.value,
    };
    // Append discount
    axiosInstance
      .post(APPPEND_DISCOUNT, discountDetails)
      .then((response) => {
        // console.log(response?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const columns = [
    {
      Header: "",
      id: "invoiceId",
      maxWidth: 10,
      minWidth: 10,
      width: 10,
      Cell: (row) => (
        <div>
          <Checkbox
            onClick={(e) => {
              // var invoicePrint_array = [...invoicePrint];
              // if (e.target.checked=== true) {
              //   invoicePrint_array = [...invoicePrint, e.target.value];
              //   console.log(invoicePrint_array, " console.log(invoicePrint);");
              //   // let Id= row.row.original.id;
              //   // let Type = row.row.original.type;
              //   //   setInvoicePrint({
              //   //     ...invoicePrint,
              //   //     id: Id,
              //   //     type:Type
              //   //   })
              // } else {
              //   invoicePrint_array.splice(
              //     invoicePrint.indexOf(e.target.value),
              //     1
              //   );
              // }
              // setInvoicePrint(invoicePrint_array);
            }}
            name={row.row.original.type}
            value={row.row.original.bookingId}
            className="accent-red-600	text-white"
          />
        </div>
      ),
    },
    {
      Header: "Payment Status",
      id: "Payment Status",
      maxWidth: 80,
      minWidth: 80,
      width: 80,

      Cell: (row) => {
        const selectedRow = row?.row?.original;
        const isCompanyPaid =
          selectedRow?.lrDetails?.length === 0
            ? selectedRow?.isCompanyPaid
            : selectedRow?.lrDetails?.find(
                (x) => x.companyId === invoiceData?.companyDetails?.companyId
              )?.isCompanyPaid;
        return (
          <CategoryPill
            onChangeValue={(e, id, type) => {
              UpdatePaymentMethod(e, id, row);
              // console.log(e, id, type)
              // console.log(row?.row?.original)
            }}
            Pending={isCompanyPaid}
            id={row?.row?.original?.bookingId}
            LrNo={row?.row?.original?.lrNo}
          />
        );
      },
    },
    {
      Header: "Date",
      accessor: (d) => {
        return moment(d.loadingDate).format("DD-MM-YYYY");
      },
      maxWidth: 80,
      minWidth: 80,
      width: 80,
      //   Footer: <span className="font-semibold text-left ">Total Amount:</span>,
    },
    {
      Header: "From",
      accessor: "from",
      maxWidth: 200,
      minWidth: 100,
      width: 100,
      //   Footer: <span className="font-semibold text-left ">Total Amount:</span>,
    },
    {
      Header: "To",
      accessor: "to",
      maxWidth: 200,
      minWidth: 100,
      width: 100,
      //   Footer: <span className="font-semibold text-left ">Total Amount:</span>,
    },
    {
      Header: "Buillty Received",
      maxWidth: 100,
      minWidth: 100,
      width: 100,
      accessor: (d) => {
        return d.isBiltyReceive ? "Yes" : "No";
      },
    },
    {
      Header: "Discount",
      maxWidth: 100,
      minWidth: 100,
      width: 100,
      accessor: (d) => {
        return (
          <Input
            defaultValue={d.discount}
            onChange={(e) => {
              discountAppend(e, d);
            }}

            // autoComplete="off"
          />
        );
      },
    },
    {
      Header: "FREIGHT",
      accessor: "freigth",
      maxWidth: 80,
      minWidth: 80,
      width: 80,
    },
    {
      Header: "Advance",
      accessor: "advance",
      maxWidth: 80,
      minWidth: 80,
      width: 80,
      Footer: <span className="font-semibold text-left ">Total</span>,
    },
    {
      Header: "Balance",
      accessor: "balance",
      maxWidth: 100,
      minWidth: 100,
      width: 100,
      Footer: <span className="font-semibold text-left ">{balance}</span>,
    },
    {
      Header: "hamali",
      accessor: (d) => {
        if (d.hamali !== null) {
          return d.hamali;
        } else {
          return 0;
        }
      },
      maxWidth: 80,
      minWidth: 80,
      width: 80,
      Footer: <span className="font-semibold text-left pb-5  ">{hamali}</span>,
    },
    {
      Header: "Detention",
      accessor: (d) => {
        if (d.detention !== null) {
          return d.detention;
        } else {
          return 0;
        }
      },
      maxWidth: 80,
      minWidth: 80,
      width: 80,
      Footer: (
        <span className="font-semibold text-left pb-5 ">{detention}</span>
      ),
    },
    {
      Header: "Extra Charge",
      accessor: (d) => {
        if (d.extraCharge !== null) {
          return d.extraCharge;
        } else {
          return 0;
        }
      },
      maxWidth: 80,
      minWidth: 80,
      width: 80,
      Footer: (
        <span className="font-semibold text-left pb-5  ">{extraCharge}</span>
      ),
    },
    {
      Header: "Total",
      accessor: "total",
      maxWidth: 110,
      minWidth: 110,
      width: 110,
      Footer: <span className="font-semibold text-left pb-5 ">{total} Dr</span>,
    },
  ];
  useEffect(() => {
    // setTransporterId(localStorage.getItem("id"));
    getCompanyInvoice(localStorage.getItem("id"));
  }, [props?.startDate, props?.endDate]); // eslint-disable-line react-hooks/exhaustive-deps

  // Get API
  const getCompanyInvoice = async (FetchTransporterId) => {
    setIsLoading(true);
    let StartDate =
      props?.startDate === undefined
        ? ""
        : moment(props?.startDate).format("YYYY-MM-DD");
    let EndDate =
      props?.endDate === undefined
        ? ""
        : moment(props?.endDate).format("YYYY-MM-DD");
    await axiosInstance
      .get(
        `${NEW_COMPANY_INVOICE}?companyId=${FetchTransporterId}&startDate=${StartDate}&endDate=${EndDate}`
      )
      .then((response) => {
        // console.log(response?.data?.data?.booking)
        setInvoiceData(response?.data?.data);
        setCompanyData(response?.data?.data?.bookings);
        setCompanyAddress(response?.data?.data?.companyDetails?.billToAddress);
        setCompanyName(response?.data?.data?.companyDetails?.name);
        setCompanyGST(response?.data?.data?.companyDetails?.gst);
        setHamali(response?.data?.data?.totalHamali);
        setDetention(response?.data?.data?.totalDetention);
        setExtraCharge(response?.data?.data?.totalExtraCharge);
        setBalance(response?.data?.data?.totalBalance);
        setTotal(response?.data?.data?.grandTotal);
        setIsLoading(false);
        return;
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
        setError(true);
        return;
      });
  };

  // Get Print Invoice API
  const PrintBtnClick = async () => {
    setIsLoading(true);
    let checkedBoxes = document.querySelectorAll(
      "input[type=checkbox]:checked"
    );
    let InvoicesPara = Array.from(checkedBoxes).map((x) => {
      return x.value;
    });
    let InvoiceDetails = {
      CompnayId: localStorage.getItem("id"),
      BookingId: InvoicesPara,
    };
    // TransporterInvoiceView
    await axiosInstance
      .post(COMPANY_PRINT_INVOICE, InvoiceDetails)
      .then((response) => {
        // console.log(response?.data);
        // if (response?.data?.data?.grandTotal) {
        history.push({
          pathname: "/company/company-invoice-view",
          data: response?.data?.data,
          address: { companyAddress },
          name: { companyName },
          gst: { companyGST },
          note: { note },
        });
        // }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
        setError(true);
      });
  };
  // Change Payment status
  const UpdatePaymentMethod = async (e, id, row) => {
    // console.log(e)
    // console.log(id)
    // console.log(type)
    // setIsLoading(true);
    // props?.ownerId
    // debugger;
    const selectedRow = row?.row?.original;
    const LrNo = selectedRow?.lrDetails?.find(
      (x) => x.companyId === invoiceData?.companyDetails?.companyId
    )?.lrNo;
    let paymentData = {
      BookingId: id,
      CompanyId: localStorage.getItem("id"),
      LrNo: LrNo || null,
    };
    await axiosInstance
      .post(COMPANY_PAYMENT, paymentData)
      .then((response) => {
        // console.log(response);
      })
      .catch((error) => {
        ConfirormationModal(error.message, "error", 2000);
      });
  };
  return (
    <section>
      <p className="text-left font-semibold	 text-xs	mt-2">
        {CheckboxDes} Invoices.
      </p>
      {isLoading && invoiceData ? (
        <Loader />
      ) : (
        <div className="mt-2">
          {error ? (
            <p className="text-warn-error">No data found</p>
          ) : (
            <>
              {/* Table call */}
              <TablePagination
                noPagination
                data={companyData}
                columns={columns}
                isFooter
              />
              {/* Calculation of  Total Amount paid to Truck Driver*/}
              <div className="flex flex-row justify-between mt-4">
                {/* Note input to show information in invoice print */}
                <div className="flex flex-row space-x-2 w-1/2">
                  <p className="text-sm">Note:</p>
                  <textarea
                    className="peer w-full px-3 py-2  border border-gray-300 placeholder-gray-500  rounded-md focus:outline-none  focus:z-10 sm:text-sm "
                    name="Note"
                    id=""
                    cols="30"
                    rows="1"
                    onChange={(e) => {
                      setNote(e.target.value);
                    }}
                    type="text"
                  ></textarea>
                </div>
              </div>
              <div className="flex mt-10 flex-row space-x-2 justify-center items-center">
                {/* {invoiceData?.details && ( */}
                <ButtonWithBG
                  label="Genrate Invoice"
                  handleClick={PrintBtnClick}
                ></ButtonWithBG>

                {/* <ButtonWithBG
                  theme="secondary"
                  label="Invoice Paid"
                  onClick={(e) => {
                    PrintBtnClick();
                  }}
                ></ButtonWithBG> */}
              </div>
            </>
          )}
        </div>
      )}
    </section>
  );
}
